// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    APIPermissions,
    APIPermissionsFromJSON,
    APIPermissionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface LoginStatus
 */
export interface LoginStatus {
    /**
     * 
     * @type {string}
     * @memberof LoginStatus
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof LoginStatus
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LoginStatus
     */
    avatarUrl: string;
    /**
     * 
     * @type {APIPermissions}
     * @memberof LoginStatus
     */
    permissions: APIPermissions;
    /**
     * 
     * @type {string}
     * @memberof LoginStatus
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof LoginStatus
     */
    onboardingStatus: LoginStatusOnboardingStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LoginStatus
     */
    acceptedCookieAgreement: boolean;
}

export function LoginStatusFromJSON(json: any): LoginStatus {
    return {
        'username': json['username'],
        'name': json['name'],
        'avatarUrl': json['avatar_url'],
        'permissions': APIPermissionsFromJSON(json['permissions']),
        'language': json['language'],
        'onboardingStatus': json['onboarding_status'],
        'acceptedCookieAgreement': json['accepted_cookie_agreement'],
    };
}

export function LoginStatusToJSON(value?: LoginStatus): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'username': value.username,
        'name': value.name,
        'avatar_url': value.avatarUrl,
        'permissions': APIPermissionsToJSON(value.permissions),
        'language': value.language,
        'onboarding_status': value.onboardingStatus,
        'accepted_cookie_agreement': value.acceptedCookieAgreement,
    };
}

/**
* @export
* @enum {string}
*/
export enum LoginStatusOnboardingStatusEnum {
    StepOne = 'step_one',
    StepTwo = 'step_two',
    Completed = 'completed'
}


